import { render } from "./tablaTutelas.vue?vue&type=template&id=5eaf8ab4&scoped=true"
import script from "./tablaTutelas.vue?vue&type=script&lang=js"
export * from "./tablaTutelas.vue?vue&type=script&lang=js"

import "./tablaTutelas.vue?vue&type=style&index=0&id=5eaf8ab4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaf8ab4"]])

export default __exports__